module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Volume-down-bea47cf5f345ce98582ecf03ae1d8d07.svg";